import React from "react";

export const PropertyCardSkeleton = () => {
  return (
    <div className="flex flex-col bg-white rounded-[24px] w-full max-w-[910px] mx-auto overflow-hidden border border-[#E5E5E5] animate-pulse">
      {/* Image / carousel area with dark header bar */}
      <div className="relative sm:h-full aspect-[16/10] bg-gray-200">
        <div className="absolute inset-x-0 top-0 h-12 lg:h-16 flex justify-between items-center px-4 bg-black/80">
          <div className="flex items-center min-w-0">
            <div className="h-6 w-24 bg-gray-600 rounded" />
          </div>
          <div className="flex items-center gap-2 flex-shrink-0">
            <div className="h-5 w-28 md:w-32 bg-gray-600 rounded-full mr-10 lg:mr-20" />
          </div>
        </div>
        <div className="absolute top-7 right-2 h-10 w-10 md:h-14 md:w-14 rounded-full bg-gray-600 border-2 border-white shadow" />
      </div>

      <div className="p-6">
        <div className="flex justify-between items-start gap-4">
          <div className="min-w-0 flex-1 flex flex-col gap-2">
            <div className="h-6 w-32 bg-gray-200 rounded-full" /> {/* price */}
            <div className="h-7 w-3/4 bg-gray-200 rounded-full" /> {/* title */}
            <div className="h-5 w-2/3 bg-gray-200 rounded-full" />{" "}
            {/* address */}
          </div>
          <div className="shrink-0 p-3 mt-0.5 bg-white rounded-full border border-[#E5E5E5]">
            <div className="h-5 w-5 bg-gray-200 rounded-full" />
          </div>
        </div>

        <div className="border-t-0 lg:border-t border-[#EAEAEA] mt-2 lg:mt-4 pt-2 lg:pt-4">
          <div className="flex flex-wrap items-center gap-3 lg:gap-6">
            <div className="h-4 w-20 bg-gray-200 rounded-full" /> {/* beds */}
            <div className="h-4 w-24 bg-gray-200 rounded-full" /> {/* baths */}
            <div className="h-4 w-24 bg-gray-200 rounded-full" /> {/* area */}
          </div>
        </div>
      </div>
    </div>
  );
};

export const PropertyCardSkeletonList = ({ count = 5 }) => {
  return (
    <div className="grid place-items-center grid-cols-1 gap-5 mb-5">
      {Array.from({ length: count }).map((_, index) => (
        <PropertyCardSkeleton key={index} />
      ))}
    </div>
  );
};
